import React from 'react';
import {useState} from 'react';
import bestsellerVideo from './../assets/video/bestseller-ipad.mp4';
import kleemannVideo from './../assets/video/kleemann.mp4';
import hugobossVideo from './../assets/video/hugoboss.mp4';
import captionflowVideo from './../assets/video/captionflow.mp4';
import ipad from './../assets/images/iPad-portrait.png';
import Captionflowcase from './../cases/captionflow.js';
import CaseVideo from './../cases/CaseVideo.js';

export default function ProjectCarousel(props){

  const [currentProjectId, setCurrentProjectId] = useState(1);
  const [showCases, setShowCases] = React.useState(true);
  const [fadeClass, setFadeClass] = React.useState("");
  // https://rahuulmiishra.medium.com/cross-fading-conditionally-rendered-react-components-f3deeb05c2cd
  // https://nextjs.org/learn/foundations/from-react-to-nextjs
  // https://react.dev/learn/passing-data-deeply-with-context

  const nextHit = () => {
    let isVisible = !showCases;
    if(isVisible){
      setShowCases(isVisible);
      setCurrentProjectId(currentProjectId === 4 ? 1 : currentProjectId + 1);
    } else {
      setShowCases(!isVisible);
      setCurrentProjectId(currentProjectId === 4 ? 1 : currentProjectId + 1);
    }
    setFadeClass(isVisible ? 'fadeIn' : 'fadeOut');
  }
  const prevHit = () => {
    setCurrentProjectId(currentProjectId === 1 ? 4 : currentProjectId - 1);
  }

  return(
    <div className="flex items-center">
      <div onClick={() => prevHit()} id="prevBtnId" className="px-2 mr-4 py-4 hidden lg:flex rounded-xl cursor-pointer hover:bg-gray-200 active:bg-gray-300"><svg className="w-10 h-10" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><path d="M14,8l-4,4l4,4" strokeLinecap="round" strokeWidth="1" stroke="#323232" fill="none" strokeLinejoin="round"></path><path fill="none" d="M0,0h24v24h-24Z"></path></svg></div>
      <div className="flex justify-center" style={{'width':props.contentWidth, 'height':props.contentHeight}}>
        <div className={`flex flex-col px-8 ${fadeClass}`}>
          {currentProjectId === 1 && showCases ? <CaseVideo fadeClass={fadeClass} showCases={setShowCases} shadow={true} src={captionflowVideo} contentWidth={props.contentWidth} contentHeight={props.contentHeight} /> : null}
          {/* Kleemann */}
          {currentProjectId === 2 && showCases ? <CaseVideo fadeClass={fadeClass} src={kleemannVideo} shadow={true} contentWidth={props.contentWidth} contentHeight={props.contentHeight} /> : null }
          {/* Bestseller */}
          {currentProjectId === 3 && showCases ? <CaseVideo fadeClass={fadeClass} src={bestsellerVideo} contentWidth={props.contentWidth} contentHeight={props.contentHeight} /> : null }
          {/* Hugo Boss */}
          {currentProjectId === 4 && showCases ? <CaseVideo fadeClass={fadeClass} src={hugobossVideo} shadow={true} contentWidth={props.contentWidth} contentHeight={props.contentHeight} /> : null }
          
          {currentProjectId === 3540 ? <div className="relative w-auto" style={{'width':props.contentWidth, 'height':props.contentHeight}}>
            <div id="bestseller" className="flex w-full h-full">
              <div className="relative w-full h-full">
                <div className="absolute top-[4.9%] left-[5.1%] scale-[80.7%] origin-top-left">
                  <video autoPlay loop muted>
                    <source src={bestsellerVideo} />
                  </video>
                </div>
                <div className="w-[87%]">
                  <div className="ipad-bg-wrapper" style={{paddingTop: '129.0%'}}><div className="shadow w-full h-full absolute top-0 left-0 lg:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] rounded-[50px]"></div><div className="ipad-bg-content" style={{backgroundSize: 'cover', backgroundImage: `url(${ipad})`}}></div></div>
                </div>
              </div>
              <div className="relative flex justify-end w-full h-full">
                <div className="absolute top-[4.9%] left-[2.7%] scale-[39.2%] origin-top-left">
                  <video autoPlay loop muted>
                    <source src={bestsellerVideo} />
                  </video>
                </div>
                <div className="w-[87%]">
                  <div className="ipad-bg-wrapper" style={{paddingTop: '129.0%'}}><div className="shadow w-full h-full absolute top-0 left-0 lg:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] rounded-[50px]"></div><div className="ipad-bg-content" style={{backgroundSize: 'cover', backgroundImage: `url(${ipad})`}}></div></div>
                </div>
              </div>
            </div>
          </div> : null }
        </div>
      </div>
      <div onClick={() => nextHit()} id="nextBtnId" className="px-2 ml-4 py-4 hidden lg:flex rounded-xl cursor-pointer hover:bg-gray-200 active:bg-gray-300"><svg className="w-10 h-10" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><path d="M10,16l4,-4l-4,-4" strokeLinecap="round" strokeWidth="1" stroke="#323232" fill="none" strokeLinejoin="round"></path><path fill="none" d="M0,0h24v24h-24Z"></path></svg></div>
    </div>
  )
}